module.exports = __webpack_public_path__ + "img/action-report-hover.67c2b699.svg";